// Описания сочетаний (пар вкусов). Авто-черновик: собирается из профилей двух
// вкусов (первая фраза описания каждого) + фразы под уровень сочетания. Тексты
// стартовые — кондитеры правят построчно. Ручные версии кладём в PAIR_DESCRIPTIONS
// по ключу пары (pairKey из flavorLevels) — они перекрывают авто-черновик.

import type { FlavorLevel } from './flavorLevels'
import { getFlavorDescription } from './flavorDescriptions'

/** Первая фраза описания вкуса (профиль). */
const firstSentence = (text?: string): string => {
  if (!text) return ''
  const i = text.indexOf('. ')
  return i === -1 ? text : text.slice(0, i + 1)
}

/** Фраза-вывод под уровень смелости сочетания. */
const LEVEL_LINE: Record<FlavorLevel, string> = {
  classic:
    'Их вкусы усиливают друг друга — это проверенное, беспроигрышное сочетание для десерта.',
  interesting:
    'Вместе они раскрываются неожиданно и интересно, придавая десерту характер.',
  bold:
    'Их контраст даёт смелый, яркий акцент — сочетание для смелого эксперимента.',
}

/** Ручные описания пар (перекрывают авто-черновик). Ключ — pairKey. */
export const PAIR_DESCRIPTIONS: Record<string, string> = {}

/**
 * Описание пары: ручное (если есть) либо авто-черновик из профилей двух вкусов.
 * @param key канонический ключ пары (pairKey из flavorLevels)
 */
export const getPairDescription = (
  key: string,
  aSlug: string,
  bSlug: string,
  level: FlavorLevel | null,
): string => {
  const manual = PAIR_DESCRIPTIONS[key]
  if (manual) return manual

  const line = level
    ? LEVEL_LINE[level]
    : 'Вместе они дают гармоничное сочетание вкусов.'
  return [
    firstSentence(getFlavorDescription(aSlug)),
    firstSentence(getFlavorDescription(bSlug)),
    line,
  ]
    .filter(Boolean)
    .join(' ')
}
